module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickNew($event)
      }
    }
  }, [_vm._v("Nueva")])])]), _vm._v(" "), (_vm.mostrarForm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.nombre),
      expression: "formData.nombre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.nombre = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.nombre.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre es requerido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.descripcion),
      expression: "formData.descripcion"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.formData.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.descripcion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.guardar($event)
      }
    }
  }, [_vm._v("Guardar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.categorias), function(categoria) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(categoria.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(categoria.descripcion))]), _vm._v(" "), _c('td', [(categoria.notificarWhatsapp) ? _c('span', {
      staticClass: "clickeable text-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleFalse(categoria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-whatsapp"
    }), _vm._v(" Incluido en notificaciones")]) : _vm._e(), _vm._v(" "), (!categoria.notificarWhatsapp) ? _c('span', {
      staticClass: "clickeable text-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleTrue(categoria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" No se notifica")]) : _vm._e()])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nombre")]), _vm._v(" "), _c('th', [_vm._v("Descripción")]), _vm._v(" "), _c('th', [_vm._v("Notificar por Whatsapp")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d18904c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categorias/Lista.vue
// module id = 1117
// module chunks = 5